export default [
  {
    header: 'users.mainVerticalMenu.usersAndRoles',
    resource: ['user', 'role', 'subscription'],
    action: 'read',
  },
  {
    title: 'users.mainVerticalMenu.users',
    icon: 'UserIcon',
    children: [
      {
        title: 'users.mainVerticalMenu.usersList',
        route: 'pages-users-list',
        resource: 'user',
        action: 'read',
      },
    ],
  },
  {
    title: 'users.mainVerticalMenu.roles',
    icon: 'UserCheckIcon',
    children: [
      {
        title: 'users.mainVerticalMenu.rolesList',
        route: 'pages-roles-list',
        resource: 'role',
        action: 'read',
      },
      {
        title: 'users.mainVerticalMenu.roleAdd',
        route: 'pages-roles-add',
        resource: 'role',
        action: 'create',
      },
    ],
  },
  {
    title: 'users.mainVerticalMenu.subscriptions',
    icon: 'BellIcon',
    children: [
      {
        title: 'users.mainVerticalMenu.subscriptionsList',
        route: 'pages-subscriptions-list',
        resource: 'subscription',
        action: 'read',
      },
    ],
  },
  {
    title: 'users.userSignUp',
    icon: 'UserPlusIcon',
    route: 'user-check-signUp',
    resource: 'user',
    action: 'read',
  },
]
